<template>
	<div>
		<div class="fotnav">

			<div class="fotnavitem" >
				<div class="fotnavitem-top" >
					<div class="fotnavit-left" @click="navtoproduct">{{product_centet}}</div>
					<div class="fotnavit-right" @click="productnone">
						<img v-if="!produfoot" src="../assets/phhomeimg/phhomesum.png" />
						<div v-if="produfoot" style="color: #fff;">一</div>
					</div>
				</div>
				<div class="fotnavitem-foo" v-if="produfoot">
					<div class="fotnavmore">
						<div class="fotnavmoreite" v-for="(item,index) in categorylist" @click="navtoproduct(item.id)">{{item.name}}</div>
					</div>
				</div>
			</div>

			<div class="fotnavitem" >
				<div class="fotnavitem-top">
					<div class="fotnavit-left" @click="navtoquery()">{{contact_us.title}}</div>
					<div class="fotnavit-right" @click="queryfoo">
						<img v-if="!queryfoot" src="../assets/phhomeimg/phhomesum.png" />
						<div v-if="queryfoot" style="color: #fff;">一</div>
					</div>
				</div>
				<div class="fotnavitem-foo" v-if="queryfoot">
					<div class="fotnavmoreite"v-for="(item,index) in contact_us.list" @click="navtoquery(item.id)">{{item.name}}</div>
				</div>
			</div>
			<div class="fotnavitem">
				<div class="fotnavitem-top" >
					<div class="fotnavit-left"  @click="navtoabout(0)">{{about_us.title}}</div>
					<div class="fotnavit-right" @click="abounone">
						<img v-if="!aboufoot" src="../assets/phhomeimg/phhomesum.png" />
						<div v-if="aboufoot" style="color: #fff;">一</div>
						<!-- <img v-if="aboufoot" src="../assets/phhomeimg/phhomejian.png" /> -->
					</div>
				</div>
				<div class="fotnavitem-foo" v-if="aboufoot">
					<div class="fotnavitemde" @click="navtoabout(index)"  v-for="(item,index) in about_us.list">
						{{item.name}}
					</div>
				</div>
			</div>
			<div class="fotnavitem" >
				<div class="fotnavitem-top">
					<div class="fotnavit-left" @click="navtocontactus()">{{follow_us.title}}</div>
					<div class="fotnavit-right" @click="contactfoo">
						<img v-if="!contactfoot" src="../assets/phhomeimg/phhomesum.png" />
						<div v-if="contactfoot" style="color: #fff;">一</div>
					</div>
				</div>
				<div class="fotnavitem-foo" v-if="contactfoot">
					<div class="fotnavmoreite"v-for="(item,index) in follow_us.list"  @click="navtocontactus(item.id)">{{item.name}}</div>
				</div>
				
			</div>
		</div>
		<div class="focusus">
			<div class="focusus-hea">
				{{info.title}}
			</div>
			<div class="focusus-cont">
				<div class="focususcont-left">
<!--					<div class="focusserve">{{info.service_time}}</div>-->
<!--					<div class="focusstitl">{{channel_data['service_work']}}</div>-->
					<div class="focusserve">{{info.telephone}}</div>
					<div class="focusstitl">销售部：0773-5831172/5835305</div>
					<div class="focusstitl">市场部：0773-2350521</div>
					<div class="focusstitl">人力资源部：0773-2350520</div>
					<div class="focusstitl">客户服务部：0773-5827898/13978361362</div>
				</div>
			</div>
			<div class="qrcode">
					<div class="contact_box">
						<ul class="code_icon">
							<li class="contact_box_title"><span >关注啄木鸟</span></li>
							<li v-for="(item,index) in icon_data" :key="index" class="icon_list">
								<img class="icon" :src="item.img" alt="" @click.stop="imgclick(item)">
								<div class="QR_code" v-if="show_code == item.name" @click.stop="">
									<div class="background"></div>
									<img :src="item.QR_code" alt="">
									<div class="QR_title">{{item.text}}</div>
								</div>
							</li>
						</ul>
					</div>
				<!-- <div class="qrcode-item">
					<img :src="channel_data['xcx_image']" />
					<div class="qrcode-ti">{{info.xcx}}</div>
				</div>
				<div class="qrcode-item">
					<img :src="channel_data['gzh_image']" />
					<div class="qrcode-ti">{{info.gzh}}</div>
				</div>
				<div class="qrcode-item">
					<img :src="channel_data['wx_image']" />
					<div class="qrcode-ti">{{info.wx}}</div>
				</div>
				<div class="qrcode-item">
					<img :src="channel_data['taobao_image']" />
					<div class="qrcode-ti">{{info.taobao}}</div>
				</div> -->
			</div>
		</div>
		<div class="footer">
			<div class="footer-hea">copyright@2014桂林市啄木鸟医疗器械有限公司版权所有</div>
			<div class="footer-title" @click="toBeiAn" style="cursor: pointer;">桂ICP备11001158号-1</div>
			<div class="footer-title">互联网药品信息服务资格证书（桂）-非经营性-2018-0004</div>
		</div>
		
	</div>
	
</template>

<script>
import {session} from '../storage/storage.js';
export default{
  data(){
    return{
		show_code:'',
      categorylist:'',
      channel_data:'',
      product_centet:"产品中心",
	  aboufoot:false,
	  produfoot:false,
	  queryfoot:false,
	  contactfoot:false,
      about_us:{
        'title':"关于我们",
        'list' :[
          {'name':"公司简介",'id':1},
          {'name':"公司环境",'id':2},
          {'name':"公司荣誉",'id':3},
          {'name':"新闻中心",'id':4}
        ]
      },
      contact_us:{
        'title':"联系我们",
        'list' :[
          {'name':"维护保养",'id':1},
          {'name':"产品视频",'id':3},
          {'name':"下载专区",'id':4}
        ]
      },
      follow_us:{
        'title':"关注我们",
        'list' :[
          {'name':"在线留言",'id':1},
          {'name':"百度地图",'id':2},
        ]
      },
      info:{
        'title':"关注我们",
        'on_line':"在线客服",
        'qq':'QQ在线',
        'service_time':"客服时间",
        'telephone':"电话咨询",
        'x_depart':"销售部",
        'fax':"传  真",
        'f_depart':"客服服务部",
		'Personnel':'人力资源部',
		'Marketing':'市场部',
        'xcx':"小程序",
        'gzh':"公众号",
        'wx':"微信商城",
        'taobao':"淘宝商城"
      },
	  icon_data:[
					{	
						name:'gong_zhong_hao',
						img:require('../assets/pchomeimg/foot_icon/公众号.png'),
						img_hover:require('../assets/pchomeimg/foot_icon/公众号_点击.png'),
						QR_code:require('../assets/pchomeimg/foot_icon/公众号二维码.png'),
						text:'公众号:啄木鸟医疗'
					},
					{	
						name:'shi_ping_hao',
						img:require('../assets/pchomeimg/foot_icon/视频号.png'),
						img_hover:require('../assets/pchomeimg/foot_icon/视频号_点击.png'),
						QR_code:require('../assets/pchomeimg/foot_icon/视频号二维码.png'),
						text:'视频号:啄木鸟医疗'
					},
					{	
						name:'xiao_cheng_xu',
						img:require('../assets/pchomeimg/foot_icon/小程序.png'),
						img_hover:require('../assets/pchomeimg/foot_icon/小程序_点击.png'),
						QR_code:require('../assets/pchomeimg/foot_icon/微信小程序二维码.png'),
						text:'小程序:啄木鸟医疗'
					},
					{	
						name:'wei_bo',
						img:require('../assets/pchomeimg/foot_icon/微博.png'),
						img_hover:require('../assets/pchomeimg/foot_icon/微博_点击.png'),
						QR_code:require('../assets/pchomeimg/foot_icon/微博二维码.png'),
						text:'微博:啄木鸟医疗'
					},
					{	
						name:'wei_xin',
						img:require('../assets/pchomeimg/foot_icon/微信支付.png'),
						img_hover:require('../assets/pchomeimg/foot_icon/微信支付_点击.png'),
						QR_code:require('../assets/pchomeimg/foot_icon/微信商城二维码.png'),
						text:'商城:啄木鸟配件'
					},
					{	
						name:'WEndo',
						img:require('../assets/pchomeimg/foot_icon/WEendo.png'),
						img_hover:require('../assets/pchomeimg/foot_icon/WEendo_点击.png'),
						QR_code:require('../assets/pchomeimg/foot_icon/WEndo根管公众号二维码.png'),
						text:'公众号:啄木鸟医疗WE根管'
					},
					{	
						name:'tao_bao',
						img:require('../assets/pchomeimg/foot_icon/淘宝.png'),
						img_hover:require('../assets/pchomeimg/foot_icon/淘宝_点击.png'),
						QR_code:require('../assets/pchomeimg/foot_icon/淘宝商城二维码.png'),
						text:'淘宝:啄木鸟医疗'
					}
				],
    }
  },
  created() {
    this.get_index_channel_data()
   // this.get_channel_product_catrgory()
    this.pageParam()
	document.addEventListener('click',(e)=>{
		let classname = e.target.classname
		console.log(classname)
		if(classname!=='QR_code'&&classname!=='icon'){
			this.show_code = ''
		}
	})
  },
  methods:{
	  imgclick(item){
		  this.show_code = item.name
	  },
	  navtoseach(){
	  	this.$router.push({path: '/phseachs'})
	  },
	  navtoquery(e){
	  	this.$router.push({path: '/phquerys',query:{e}})
	  },
	  navtoelites(){
	  	this.$router.push({path: '/phelites'})
	  },
	  navtocontactus(e){
	  	this.$router.push({path: '/phcontactus',query:{e}})
	  },
	  navtovideos(){
	  	this.$router.push({path: '/phvideos'})
	  },
	  navtocompany(){
	  	this.$router.push({path: '/phcompany'})
	  },
	  navtolangu(){
	  	this.$router.push({path: '/phlangu'})
	  },
	  navtoabout(index){
		  if(index == 0){
			if( this.$route.path == '/phabout'){
				window.scrollTo(0,0)
			}else{
	  			this.$router.push({path: '/phabout'})
			}
			return
		  }else if(index == 1){
				this.navtoenviron()
		  }else if(index == 2){
				this.navtohonor()
		  }else if(index == 3){
				this.navtonews()
		  }
	  },
	  navtoenviron(){
	  	this.$router.push({path: '/phenviron'})
	  },
	  navtohonor(){
	  	this.$router.push({path: '/phhonor'})
	  },
	  navtonews(){
	  	this.$router.push({path: '/phnews'})
	  },
	  navtoproduct(e){
	  	this.$router.push({path: '/phproduct',query:{e}})
	  },
	  contactfoo(){
		 if(this.contactfoot){
		 			  this.contactfoot=false
		 }else{
		 			  this.contactfoot=true
		 } 
	  },
	  queryfoo(){
		  if(this.queryfoot){
		  			  this.queryfoot=false
		  }else{
		  			  this.queryfoot=true
		  }
	  },
	  productnone(){
		  if(this.produfoot){
		  			  this.produfoot=false
		  }else{
		  			  this.produfoot=true
		  }
	  },
	  abounone(){
		  if(this.aboufoot){
			  this.aboufoot=false
		  }else{
			  this.aboufoot=true
		  }
		
	  },
    get_channel_product_catrgory(){
      let data={
        lang:session.get('lang'),
        channel_id: session.get('channel_id'),
        // page:1,
        // pageSize:12,
      }
      this.$api.get_channel_category_list(data).then((res) => {
        this.categorylist=res.data
      });
    },
    get_index_channel_data(){
      let data= {
        mold: "pc",
        lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
        channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
      };
      this.$api.get_channel_index(data).then((res) => {
        this.channel_data =  res.data;
        /* this.pageParam() */
      });
    },
    pageParam(){
      this.get_channel_product_catrgory();
      let lang =  session.get("lang");
      if (lang === "cn"){
        this.product_centet = "产品中心",
            this.about_us = {
              'title':"关于我们",
              'list' :[
				{'name':"关于啄木鸟",'id':1},
				{'name':"公司环境",'id':2},
				{'name':"公司荣誉",'id':3},
				{'name':"新闻中心",'id':4}
              ]
            },
            this.contact_us ={
              'title':"用户服务",
              'list' :[
                {'name':"防伪鉴别",'id':1},
                {'name':"维护保养",'id':2},
                /* {'name':"经销商登入",'id':2}, */
                {'name':"资料下载",'id':3},
                {'name':"常见问题",'id':4}
              ]
            },
            this.follow_us = {
              'title':"联系我们",
              'list' :[
                {'name':"在线留言",'id':2},
                {'name':"百度地图",'id':1},
              ]
            },
            this.info = {
              'title':"关注我们",
				'on_line':"在线客服",
				'qq':'QQ在线',
				'service_time':"客服时间",
				'telephone':"电话咨询",
				'x_depart':"销售部",
				'fax':"传  真",
				'f_depart':"客服服务部",
				'Personnel':'人力资源部',
				'Marketing':'市场部',
				'xcx':"小程序",
				'gzh':"公众号",
				'wx':"微信商城",
				'taobao':"淘宝商城"
            }

      }else{
        this.product_centet = "PRODUCTS",
            this.about_us = {
              'title':"ABOUT US",
              'list' :[
                {'name':"About Woodpecker",'id':1},
                {'name':"Company Corner",'id':2}, 
                {'name':"Honors",'id':3},
                {'name':"News",'id':4}
              ]
            },
            this.contact_us ={
              'title':"USER SERVICE",
              'list' :[
                {'name':"Maintenance",'id':1},
                {'name':"Dealer login",'id':2},
                {'name':"Video",'id':3},
                {'name':"Download",'id':4}
              ]
            },
            this.follow_us = {
              'title':"CONTACT US",
              'list' :[
                {'name':"Online Message",'id':1},
                {'name':"Map",'id':2},
              ]
            },
            this.info = {
              'title':"FOLLOW US",
              'on_line':"Service",
              'qq':'Online',
              'service_time':"User Service Time",
              'telephone':"Telephone Consultation",
              'x_depart':"Sales Department",
              'fax':"Fax",
              'f_depart':"Service Department",
              'xcx':"Applet",
              'gzh':"Official Account",
              'wx':"Wechat Mall",
              'taobao':"Taobao Mall"
            }
      }


    },
	  scrollIntoView(id){
		  this.$nextTick(function () {
			  var dom = document.getElementById(id)
			  if(dom != null){
				  dom.scrollIntoView()
			  }
		  })
	  },
	  toBeiAn(){
	  	window.location.href = 'https://beian.miit.gov.cn'
	  },


  }
}
</script>

<style>
	.fotnav{
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		background: #272727;
		padding-bottom: 0.4rem;
		padding-top: 0.4rem;
	}
	
	.fotnavitem{
		width: 6.9rem;
		box-shadow: 0rem 0.01rem 0rem 0rem #FAFAFA;
	}
	.fotnavit-left{
		font-size: 0.26rem;
		font-weight: 400;
		color: #FFFFFF;
		letter-spacing: 0.01rem;
	}
	.fotnavit-right{
		width: 0.22rem;
		height: 0.22rem;
	}
	.fotnavit-right img{
		width: 0.22rem;
		height: 0.22rem;
	}
	.focusus{
		padding: 0 0.3rem;
		background: #272727;
		padding-bottom: 0.6rem;
	}
	.focusus-hea{
		font-size: 0.26rem;
		font-weight: 400;
		color: #FFFFFF;
		letter-spacing: 0.01rem;
	}
	.focusus-cont{
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.focusserve{
		font-size: 0.2rem;
		font-weight: 400;
		color: #CCCCCC;
		letter-spacing: 0.01rem;
		margin-top: 0.24rem;
	}
	.focusstitl{
		font-size: 0.2rem;
		font-weight: 400;
		color: #CCCCCC;
		letter-spacing: 0.01rem;
		margin-top: 0.12rem;
	}
	.phser{
		
		height: 0.42rem;
		border-radius: 0.04rem;
		border: 0.01rem solid #EAEAEA;
		
		font-size: 0.1rem;
		font-weight: 400;
		color: #FAFAFA;
		margin-top: -0.9rem;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.phser img{
		width: 0.24rem;
		height: 0.24rem;
		min-height: 0.24rem !important;
		min-width:  0.24rem !important;
		margin-right: 0.06rem;
	}
	.qqser{
		width: 1.5rem;
		height: 0.42rem;
		border-radius: 0.04rem;
		border: 0.01rem solid #EAEAEA;
		
		font-size: 0.1rem;
		font-weight: 400;
		color: #FAFAFA;
		margin-top: 0.5rem;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.qqser img{
		width: 0.24rem;
		height: 0.24rem;
		min-height: 0.24rem !important;
		min-width:  0.24rem !important;
		margin-right: 0.06rem;
	}
	
	.qrcode{
		/* display: flex; */
		align-items: center;
		justify-content: center;
		margin-top: 0.3rem;
	}
	.qrcode-item{
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		margin-left: 0.57rem;
	}
	.qrcode-item:first-child{
		margin-left: 0rem;
	}
	.qrcode-item img{
		width: 1.3rem;
		height: 1.3rem;
	}
	.qrcode-ti{
		font-size: 0.24rem;
		font-weight: 400;
		color: #CCCCCC;
		letter-spacing: 0.01rem;
		margin-top: 0.2rem;
	}
	.footer{
		background: #272727;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		width: 7.5rem;
		background: #272727;
		box-shadow: 0rem -0.01rem 0rem 0rem #666666;
		padding-bottom: 0.2rem;
	}
	.footer-hea{
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 0.16rem;
		font-weight: 400;
		color: #666666;
		margin-top: 0.2rem;
	}
	.footer-title{
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 0.16rem;
		font-weight: 400;
		color: #666666;
		margin-top: 0.1rem;
	}
	
	.fotnavitem-top{
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 6.9rem;
		height: 0.9rem;
		font-size: 0.26rem;
		font-weight: 400;
		color: #FFFFFF;
		letter-spacing: 0.01rem;
	}
	.fotnavitem-foo{
		font-size: 0.20rem;
		font-weight: 400;
		color: #FFFFFF;
		letter-spacing: 0.01rem;
		margin-bottom: 0.18rem;
	}
	.fotnavitemde{
		margin-top: 0.24rem;
	}
	.fotnavimg{
		display: flex;
		overflow: auto;
		flex-wrap: nowrap;
	}
	.fotnavimgcon{
		width: 2.4rem;
		height: 2.4rem;
		display: flex;
		justify-content: center;
		flex-direction: column;
		align-items: center;
		margin-right: 0.25rem;
	}
	.fotnavimgcon img{
		width: 2rem;
		height: 2rem;
	}
	.fotnavmore{
		margin-bottom: 20px;
	}
		
	.fotnavmoreite{
		margin-bottom: 20px;
	}


	.contact_box{
		/*margin-left: 25px;*/
		font-size: 14px;
		padding-top: 0px;
		/* display: block; */
		/* padding-left: 100px; */
	}
	.contact_box_title{
	color: #CCCCCC;
	margin-bottom: 5px;
}
.contact_box_title span{
	position: relative;
}
.contact_box_title img{
	width: 0.4rem;
	height: 0.4rem;
	position: absolute;
	left:-25px;
	top: 0;
}
.code_icon .contact_box_title{
	display: block;
	padding-bottom: 30px;
}
.code_icon li{
	display: inline-block;
}
.code_icon span{
	margin-right: 10px;
	font-size: .25rem;
}
</style>

<style scoped>
li{
	list-style: none;
	position: relative;

}
ul{
	padding:0;
	cursor: auto;
}
.icon{
	width: 0.6rem;
	height: 0.6rem;
}
.icon_list{
	margin-right: calc(10rem / 50);
	position: relative;
	cursor: pointer;
}

.lang_text{
	width: 0.6rem;
	font-size: 12px;
	color: #CCCCCC;
	position: absolute;
	text-align: center;
	left: 0;
	top: calc(22rem / 50);
}
.aboutitem_section{
	position: absolute;
	right: calc(240rem / 50);
}
.QR_code{
	width: calc(100rem / 50);
	height: calc(130rem / 50);
	position: absolute;
	left: calc(-0rem / 50);
    top: calc(-130rem / 50);
	/* left: 0;
	top: 0; */
	/* transition: all 0.5s; */
}
.QR_code img{
	width: calc(100rem / 50);
	height: calc(100rem / 50);
	position: absolute;
}
.background{
	width: calc(100rem / 50);
	height: calc(130rem / 50);
	background-color: #FFFFFF;
	position: absolute;
	left: 0;
	top: 0;
	z-index: -0.5;
}
.QR_title{
	width: calc(100rem / 50);
	height: calc(30rem / 50);
	position: absolute;
    bottom: 0;
    text-align: center;
	font-size: calc(10rem / 50);
    color: #8a8f99;
}
</style>
